<!-- app.component.html -->
<router-outlet></router-outlet>

<!-- Chatbot Icon -->
<div class="chatbot-icon" *ngIf="isLoggedIn" (click)="toggleChat()">
  <img *ngIf="!isChatOpen" src="assets/img/chatbot.png" alt="Chatbot Avatar" class="bot-avatar">
  <span *ngIf="isChatOpen" class="close-icon">&#x2715;</span>
</div>

<!-- Chat Window -->
<div class="chat-window" *ngIf="isChatOpen && isLoggedIn ">
  <div class="chat-header">
    <img src="assets/img/chatbot.png" alt="Chatbot Avatar" class="chat-avatar">
    <div class="chat-title">
      <h4>I'm Sandy </h4>
      <p>Your contract AI Assistant</p>
    </div>
    <button class="minimize-btn" (click)="toggleChat()">
      <span>&#8722;</span>
    </button>
  </div>

  <!-- Welcome Tab -->
  <div class="chat-body" *ngIf="selectedTab === 'welcome'">
    <div class="welcome-container">
      <p class="welcome-message">
        Hi I'm Sandy - Your digital CLM Assistant. I can provide you...
      </p>
      
      <div class="service-options">
        <div class="service-option">
          <h5>Quote  –</h5>
          <p>Your contract assistant</p>
        </div>
        
 
        
        <div class="service-option">
          <h5>Information –</h5>
          <p>Interactively ask any questions</p>
        </div>
        
        <div class="service-option">
          <h5>Questions</h5>
          <p>Ask any questions related to contracts</p>
        </div>
      </div>
    </div>

    <div class="quick-options">
   
      <button class="option-btn" (click)="selectTab('information')">Information</button>
      <button class="option-btn" (click)="selectTab('calculator')">Contracts</button>
      <button class="option-btn" (click)="selectTab('checker')">Parties</button>
      <button class="option-btn" (click)="selectTab('connect')">Connect with Us</button>
    </div>
  </div>

  <!-- Chat Messages Tab -->
  <div class="chat-body" *ngIf="selectedTab !== 'welcome'">
    <div class="chat-messages">
      <div *ngFor="let chat of chatHistory" 
           [ngClass]="{'bot-message': chat.isBot, 'user-message': !chat.isBot}">
        <img *ngIf="chat.isBot" src="assets/chatbot-avatar.png" alt="Bot" class="message-avatar">
        <div class="message-content">{{ chat.message }}</div>
      </div>
    </div>

    <div class="back-to-menu">
      <button class="menu-btn" (click)="selectTab('welcome')">Back to Menu</button>
    </div>
  </div>

  <div class="chat-footer">
    <input type="text" placeholder="Type your message..." [(ngModel)]="message" (keyup.enter)="sendMessage()">
    <button (click)="sendMessage()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
      </svg>
    </button>
  </div>
</div>